import React from 'react';
import { IPdfViewProps } from 'shared/components/PdfViewer/PdfView';
import { AuthenticatedPdfView } from 'shared/components/PdfViewer/AuthenticatedPdfView';
import { Box, CircularProgress } from '@material-ui/core';

interface IPdfViewWithStatusCheckPdf extends IPdfViewProps {
    errorRender: React.ReactElement;
    isPdfChecking: boolean;
    isPdfAvailable: boolean;
}

export const PdfViewWithStatusCheck = ({
    isPdfChecking,
    isPdfAvailable,
    errorRender,
    ...props
}: IPdfViewWithStatusCheckPdf) => {
    if (isPdfChecking) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                height="100%"
                flexGrow={1}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (isPdfAvailable) {
        return (
            <AuthenticatedPdfView {...props} errorRender={errorRender} />
        );
    }

    return (
        <>{errorRender}</>
    );
};
